export default "__VITE_ASSET__DHUUhOBf__"